
import { createSlice } from '@reduxjs/toolkit';


const initialState = {
    loading: false,
    data: {},
    error: false,
    lastFetched: null,
};

// Try to load from localStorage
const saved = localStorage.getItem('tenant_alarm');
if (saved) {
    try {
        const parsed = JSON.parse(saved);
        initialState.data = parsed.data || {};
        initialState.lastFetched = parsed.lastFetched || null;
    } catch (err) {
        console.error('Error parsing localStorage tenant alarm cache:', err);
    }
}

export const tenantAlarmCountSlice = createSlice({
    name:'TENANT_ALARM_COUNT',
    initialState:initialState,
    reducers:{
        TENANT_ALARM_COUNT_FETCH_START:(state)=>{
            state.loading=true
        },
        TENANT_ALARM_COUNT_FETCH_SUCCESS:(state,action)=>{
            state.loading=false
                 state.data = action.payload;
            state.lastFetched = Date.now();

            // ✅ Save to localStorage
            localStorage.setItem('tenant_alarm', JSON.stringify({
                data: action.payload,
                lastFetched: Date.now()
            }));
        },
        TENANT_ALARM_COUNT_FETCH_ERROR:(state)=>{
            state.error=true
        }
    }
});

export const { TENANT_ALARM_COUNT_FETCH_START,TENANT_ALARM_COUNT_FETCH_SUCCESS,TENANT_ALARM_COUNT_FETCH_ERROR }=tenantAlarmCountSlice.actions;
export default tenantAlarmCountSlice.reducer;